<template>
  <div>
    <embed-api-table
    title="Client Primary Photo"
    module="Client-Images"
    v-bind:add-new-text="addNewText"
    @add-new="addNew"
    @click="imageClicked"
    v-bind:columns="imageColumns"
    v-bind:filter="imageFilter"
    v-bind:refresh-for-id="lastRefreshTime">
    </embed-api-table>
    
    <add-client-images @added="onImageAdded" v-bind:client-id="clientId"></add-client-images>
    <preview-image dlg-id="client-image-preview" v-bind:image-blob="previewBlob"></preview-image>
  </div>
</template>

<script>
  import EmbedApiTable from "./EmbedApiTable.vue";
  import AddClientImages from "./AddClientImages.vue";
  import PreviewImage from "./PreviewImage.vue";
  import WebLLCRESTApi from "../api/api";
  import $ from "jquery";
  
  
  export default {
    props: {
      clientId: String,
      canSave: Boolean
    },
    created() {
      // prepare api
      this.api = new WebLLCRESTApi("Client-Images", this.$router);
    },
    
    
    data() {
      return {
        addNewText: (this.canSave ? "Add New Images" : null),
        
        imageColumns: this.getColumns(),
        
        imageFilter: { clientId: this.clientId },
        
        lastRefreshTime: "0",
        
        previewBlob: null
      };
    },
    
    
    methods: {
      addNew() {
        $('#modal-add-images-data').modal('toggle');
      },
      
      onImageAdded() {
        // change the last refresh date so the table refreshes
        this.lastRefreshTime = Date.now().toString();
      },
      
      async imageClicked(data) {
        const image = data.item.item;
        
        if(data.col.text == "View Image") {
          // download the image from the api
          const res = await this.api.remoteMethod(image.id + "/image");
          this.previewBlob = await res.blob();
          
          // open our preview dialog
          $('#client-image-preview').modal('toggle');
        }
      },
      
      getColumns() {
        const cols = [
          { key: "main", "text": "Main Image", type: "Boolean" },
          { key: "description", "text": "Description", type: "String" },
          { key: "view", "text": "View Image", type: "Event" }
        ];
        
        if(this.canSave) {
          cols.unshift({ key: "bulkdelete", "text": "", type: "BulkDelete" });
          cols.push({ key: "delete", "text": "Delete", type: "Delete", sort: false });
        }
        
        return cols;
      }
    },
    
    watch: {
      canSave(to, from) {
        this.addNewText = (this.canSave ? "Add New Images" : null);
        this.imageColumns = this.getColumns();
      }
    },

    components: {
      EmbedApiTable,
      AddClientImages,
      PreviewImage
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ClientImagesTable.vue